<template>
  <div class="detail">
    <div>
      <button
        class="buto"
        @click="$router.back()"
      >返回</button>
    </div>

    <div>
      <van-row style="text-align: center;margin-top:20px;font-size: 12px;height: 20px;line-height: 20px;">
        <van-col span="2">序号</van-col>
        <van-col span="4">状态</van-col>
        <van-col span="3">操作</van-col>
        <van-col span="4">姓名</van-col>
        <van-col span="2">性别</van-col>
        <van-col span="9">身份证</van-col>
      </van-row>

      <div
        v-for="(item,index) in List"
        :key="index"
      >
        <van-row class="box-content">
          <van-col span="2">{{index+1}}</van-col>
          <van-col
            span="4"
            style=" line-height: 20px;"
          >
            <div
              class="status-content"
              :class="item.status==0?'audit-bg-color':(item.status==1?'hire-bg-color':'refuse-bg-color')"
            >{{item.status==0?'审核中':(item.status==1?'已录用':'已拒绝')}}</div>
          </van-col>
          <van-col
            span="3"
            style=" line-height: 20px;"
          >
            <div style="display: flex;justify-content: space-evenly;">
              <van-tag
                type="danger"
                size="medium"
                @click="onDelete(item)"
              >删除</van-tag>
            </div>
          </van-col>

          <van-col
            span="4"
            style=" line-height: 20px;"
          >{{item.name}}</van-col>
          <van-col
            span="2"
            style=" line-height: 20px;"
          >{{item.sex}}</van-col>
          <van-col
            span="9"
            style=" line-height: 20px;"
          >{{item.idnumber}}</van-col>
        </van-row>

      </div>

    </div>

    <div class="footers">
      <button
        class="buttons cwbf"
        style="background-color: aqua;"
        @click="goPeople()"
      >录入伙伴</button>
      <button
        class="buttons cwbf"
        style="background-color: aqua;"
        @click="goBatch()"
      >批量录入伙伴</button>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant'
export default {
  data() {
    return {
      project_id: '',
      List: null,
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.getList()
  },
  methods: {
    getList() {
      this.$axios
        .get('partner/list-in-project', {
          params: {
            project_id: this.project_id,
          },
        })
        .then((res) => {
          console.log(res)
          this.List = res.data.data
        })
    },
    goPeople() {
      this.$router.push({
        path: '/registerPeople',
        query: {
          project_id: this.project_id,
        },
      })
    },
    goBatch() {
      this.$router.push({
        path: '/batchInputPeople',
        query: {
          project_id: this.project_id,
        },
      })
    },
    onDelete(item) {
      Dialog.alert({
        message: '确认删除',
        showCancelButton: true,
      })
        .then((res) => {
          this.$axios
            .post('partner/remove', {
              id: item.id,
            })
            .then((res) => {
              this.$toast(res.data.message)
              this.getList()
            })
        })
        .catch((err) => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.detail {
  padding: 20px 10px;
}
.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
}

.buttons {
  color: #fff;
  padding: 9px 20px;
  border: none;
  border-radius: 6px;
}
.cwbf {
  color: #000;
  border: 1px solid #666;
}

.buto {
  vertical-align: top;
  background-color: #ee0a24;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
}
.box-content {
  text-align: center;
  margin-top: 5px;
  font-size: 12px;
  height: 20px;
  line-height: 20px;

  .status-content {
    width: 100%;
    border-radius: 5px;
    color: #fff;
  }
  .audit-bg-color {
    background-color: #ffb800;
  }
  .hire-bg-color {
    background-color: limegreen;
  }
  .refuse-bg-color {
    background-color: #ee0a24;
  }
}
.line-20 {
  line-height: 20px;
}
</style>